/** API base URLs: use apiBaseAddress / dataApiBaseAddress here; UrlInterceptor replaces with env (single source in environment.*.ts).
 *
 * `plato_search_*` is the standard placeholder consumers should use. On the
 * `platex-dev2` Amplify build it is sed-rewritten to the Mode 2 Lambda for
 * the `search_v3` experiment. Use `plato_search_canonical_*` instead for
 * endpoints that must ALWAYS reach plato-search regardless of dev2's Mode 2
 * rewrite — i.e. `process=new-release`, `process=new-release-name`, and any
 * other process Mode 2 does not yet implement. See environment.prod.ts for
 * the deliberate split-string that dodges the Amplify sed.
 */
export const HTTPCONSTANTS = {
  plato_search_protocol: '[HTTP-PLATO-SEARCH-PROTOCOL]',
  plato_search_base: '[HTTP-PLATO-SEARCH-BASE]',
  plato_search_canonical_protocol: '[HTTP-PLATO-SEARCH-CANONICAL-PROTOCOL]',
  plato_search_canonical_base: '[HTTP-PLATO-SEARCH-CANONICAL-BASE]',
  platoProtocol: '[HTTP-PLATO-PROTOCOL]',
  protocol: '[HTTP-API-PROTOCOL]',
  apiBaseAddress: '[HTTP-API-BASE-ADDRESS]',
  dataApiProtocol: '[HTTP-DATA-API-PROTOCOL]',
  dataApiBaseAddress: '[HTTP-DATA-API-BASE-ADDRESS]',
  platoBaseAddress: '[HTTP-PLATO-BASE-ADDRESS]',
  // Editorial Intelligence ONLY. This is the isolated Dev2 Plato FastAPI/Lambda
  // HttpApi (NOT the .NET api-dev2 host). UrlInterceptor swaps these for env.
  editorialApiProtocol: '[HTTP-EDITORIAL-API-PROTOCOL]',
  editorialApiBaseAddress: '[HTTP-EDITORIAL-API-BASE-ADDRESS]',
  // Names Register (process=names-register). Resolves from
  // environment.namesRegister* — local dev points at the local artifact server,
  // deployed builds at plato-search canonical (Mode 2 does not implement it).
  names_register_protocol: '[HTTP-NAMES-REGISTER-PROTOCOL]',
  names_register_base: '[HTTP-NAMES-REGISTER-BASE]',
  // Mode 2 production search Lambda endpoint (GET /search?process=search_v3&term=...).
  // Set in environment.{prod,ts} as mode2Protocol + mode2BaseAddress.
  // Intercepted by UrlInterceptor before canonical and plato-search checks.
  mode2_protocol: '[HTTP-MODE2-PROTOCOL]',
  mode2_base: '[HTTP-MODE2-BASE]',
  // Shadow log endpoint (POST /shadow-log, PATCH /shadow-log/:id).
  shadow_log_protocol: '[HTTP-SHADOW-LOG-PROTOCOL]',
  shadow_log_base: '[HTTP-SHADOW-LOG-BASE]',
  serverError: 'Something Went Wrong',
  incorrectLogin: 'Incorrect details, please try again.',
};
